import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const ContactSection = ({ settings }) => {
    const {
        title = "Get in Touch",
        address = "123 Store Street, City, Country",
        phone = "+1 234 567 890",
        email = "support@store.com",
        hours = "Mon - Fri: 9am - 5pm",
        bg,
        titleColor,
        titleSize,
        labelColor,
        labelSize,
        textColor,
        textSize,
        iconColor,
        iconSize
    } = settings;

    return (
        <div
            className="w-full py-16 px-4"
            style={{
                backgroundColor: bg || 'var(--store-bg)',
                color: 'var(--store-text)'
            }}
        >
            <div className="max-w-4xl mx-auto">
                {title && (
                    <h2
                        className="font-bold text-center mb-12"
                        style={{
                            color: titleColor || 'inherit',
                            fontSize: titleSize ? `${titleSize}px` : '1.875rem' // 3xl fallback
                        }}
                    >
                        {title}
                    </h2>
                )}

                <div className="grid grid-cols-2 lg:grid-cols-1 gap-12 lg:gap-8">
                    {/* Contact Info */}
                    <div className="flex flex-col justify-center">
                        <div className="space-y-8">
                            {address && (
                                <div className="flex items-start gap-6 group">
                                    <div
                                        className="p-0 transition-opacity"
                                        style={{ color: iconColor || 'inherit', opacity: iconColor ? 1 : 0.8 }}
                                    >
                                        <MapPin size={iconSize || 24} strokeWidth={1.5} />
                                    </div>
                                    <div>
                                        <h3
                                            className="font-medium mb-2"
                                            style={{
                                                color: labelColor || 'inherit',
                                                fontSize: labelSize ? `${labelSize}px` : '1.25rem' // xl fallback
                                            }}
                                        >
                                            Visit Us
                                        </h3>
                                        <p
                                            className="leading-relaxed"
                                            style={{
                                                color: textColor || 'var(--store-muted)',
                                                fontSize: textSize ? `${textSize}px` : '1.125rem' // lg fallback
                                            }}
                                        >
                                            {address}
                                        </p>
                                    </div>
                                </div>
                            )}

                            {phone && (
                                <div className="flex items-start gap-6 group">
                                    <div
                                        className="p-0 transition-opacity"
                                        style={{ color: iconColor || 'inherit', opacity: iconColor ? 1 : 0.8 }}
                                    >
                                        <Phone size={iconSize || 24} strokeWidth={1.5} />
                                    </div>
                                    <div>
                                        <h3
                                            className="font-medium mb-2"
                                            style={{
                                                color: labelColor || 'inherit',
                                                fontSize: labelSize ? `${labelSize}px` : '1.25rem'
                                            }}
                                        >
                                            Call Us
                                        </h3>
                                        <p
                                            className="leading-relaxed"
                                            style={{
                                                color: textColor || 'var(--store-muted)',
                                                fontSize: textSize ? `${textSize}px` : '1.125rem'
                                            }}
                                        >
                                            {phone}
                                        </p>
                                    </div>
                                </div>
                            )}

                            {email && (
                                <div className="flex items-start gap-6 group">
                                    <div
                                        className="p-0 transition-opacity"
                                        style={{ color: iconColor || 'inherit', opacity: iconColor ? 1 : 0.8 }}
                                    >
                                        <Mail size={iconSize || 24} strokeWidth={1.5} />
                                    </div>
                                    <div>
                                        <h3
                                            className="font-medium mb-2"
                                            style={{
                                                color: labelColor || 'inherit',
                                                fontSize: labelSize ? `${labelSize}px` : '1.25rem'
                                            }}
                                        >
                                            Email Us
                                        </h3>
                                        <p
                                            className="leading-relaxed"
                                            style={{
                                                color: textColor || 'var(--store-muted)',
                                                fontSize: textSize ? `${textSize}px` : '1.125rem'
                                            }}
                                        >
                                            {email}
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Business Hours */}
                    <div className="flex flex-col justify-center lg:pt-8 lg:border-t border-[var(--store-border)]">
                        <div className="flex items-start gap-6 group">
                            <div
                                className="p-0 transition-opacity"
                                style={{ color: iconColor || 'inherit', opacity: iconColor ? 1 : 0.8 }}
                            >
                                <Clock size={iconSize || 24} strokeWidth={1.5} />
                            </div>
                            <div>
                                <h3
                                    className="font-medium mb-2"
                                    style={{
                                        color: labelColor || 'inherit',
                                        fontSize: labelSize ? `${labelSize}px` : '1.25rem'
                                    }}
                                >
                                    Business Hours
                                </h3>
                                <p
                                    className="leading-relaxed whitespace-pre-line"
                                    style={{
                                        color: textColor || 'var(--store-muted)',
                                        fontSize: textSize ? `${textSize}px` : '1.125rem'
                                    }}
                                >
                                    {hours}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactSection;
